import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    network: true, 
  },
  mutations: {
    changeNetwork: function (state, payload) {
			state.network = payload;
		},
  },
  actions: {},
  modules: {}
});
